import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { GameService } from '../../services/game.service';
import {LeaderboardService} from "../../services/leaderboard.service";
import {Router} from "@angular/router"; // Adjust path as per your project structure



@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit {

  banners: any[] = [];
  welcomeBanners: any[] = [
      {
          "id": 1,
          "name": "Yo Numbers",
          "image":"assets/img/homebanners/YoNumbers_EconetOnlineArcadeBanner.jpg"
      } ,  {
          "id": 3,
          "name": "Yo GamesPro",
          "image":"assets/img/homebanners/YoGamezPro_BannerImage_EconetPlayBanner.jpg"
      }, {
          "id": 6,
          "name": "Spin & Win",
          "image":"assets/img/homebanners/Spin&Win.png"
      }, {
          "id": 7,
          "name": "MyKidzHub",
          "image":"assets/img/homebanners/MyKidzHub_EconetOnlineArcadeBanner.jpg"
      }
  ];
  userAccounts: any[] = [];
  games: any[] = [];
  currentBannerIndex = 0;
  gamesLoaded : boolean = false;
    usersLoaded : boolean = false;
  @ViewChild('carousel') carousel: ElementRef | undefined;
    pageNo = 1;
    pageSize = 10;

  constructor(private gameService: GameService,private _leaderboardService:LeaderboardService, private router :Router) { }

  ngOnInit(): void {
    // this.fetchBanners();
    this.fetchUserAccounts();
    this.fetchGames();
    setInterval(() => {
      this.nextBanner();
    }, 5000); // Change banner every 5 seconds

  }

  fetchBanners(): void {
    this.gameService.getBanners().subscribe(
        (data: any[]) => {
          this.banners = data;
        },
        (error) => {
          console.error('Error fetching banners:', error);
        }
    );
  }
  fetchUserAccounts(): void {
    this._leaderboardService.getAllUserAccounts(this.pageNo,this.pageSize).subscribe(
        (data:any) => {
          this.userAccounts = data.userAccountsDto;
            this.usersLoaded = true;
        },
        (error) => {
          console.error('Error fetching userAccounts:', error);
        }
    );
  }

  nextBanner(): void {
    if (this.carousel) {
      this.currentBannerIndex = (this.currentBannerIndex + 1) % this.welcomeBanners.length;
      this.carousel.nativeElement.style.backgroundImage = `url(${this.welcomeBanners[this.currentBannerIndex].image})`;
    }
  }

  fetchGames() {
    this.gameService.getGames().subscribe(
        (data: any[]) => {
          this.games = data;
            this.gamesLoaded=true;
          console.log(data); // Assuming your service returns an array of game objects
        },
        (error) => {
          console.error('Error fetching games:', error);
        }
    );
  }
    routeToPage(page: string) {
        this.router.navigate([page])
    }
}
